import type { StatusTone } from '../../design-system';

export function requestStatus(status: string, cancellationStatus?: string): { label: string; tone: StatusTone; closed: boolean } {
  if (cancellationStatus === 'SUBMITTED' && status !== 'CANCELLED') return { label: '취소 승인 대기', tone: 'warning', closed: false };
  const presentation: Record<string, { label: string; tone: StatusTone; closed: boolean }> = {
    DRAFT: { label: '작성 중', tone: 'neutral', closed: false },
    SUBMITTED: { label: '승인 대기', tone: 'warning', closed: false },
    APPROVED: { label: '승인 완료', tone: 'success', closed: false },
    REJECTED: { label: '반려', tone: 'danger', closed: true },
    DENIED: { label: '반려', tone: 'danger', closed: true },
    CANCELLED: { label: '취소됨', tone: 'neutral', closed: true },
  };
  return presentation[status] ?? { label: status, tone: 'neutral', closed: false };
}

export function entryStatus(status: string): { label: string; tone: StatusTone; closed: boolean } {
  if (status === 'CONFIRMED') return { label: '확정', tone: 'success', closed: false };
  if (status === 'CANCELLED') return { label: '취소됨', tone: 'neutral', closed: true };
  return { label: status, tone: 'neutral', closed: false };
}

export function absenceSourceLabel(value?: string): string {
  const labels: Record<string, string> = { REQUEST: '신청으로 생성', HR_DIRECT: '관리자 직접 등록', HR_CORRECTION: '관리자 정정', ACCRUAL_PERIOD_RUN: '정기 발생 처리', ENTITLEMENT_TRANSACTION: '관리자 잔액 변경', WORKER_ENTITLEMENT: '휴가 부여 정책', DIRECT: '관리자 직접 등록', CORRECTION: '관리자 정정', TIME_OFF_ENTRY: '휴가 사용 기록', TIME_OFF_REQUEST: '휴가 신청', ANNUAL_GRANT: '연차 부여', GRANT: '관리자 추가 부여', ADJUSTMENT: '잔액 조정', ACCRUAL: '정기 발생', CARRY_OVER: '이월', EXPIRATION: '만료', MANUAL: '관리자 입력', POLICY: '휴가 정책', SYSTEM: '자동 처리' };
  return value ? labels[value] ?? '기타 처리' : '휴가 신청';
}

export function absenceTransactionLabel(value: string): string {
  const labels: Record<string, string> = { GRANT: '추가 부여', ADJUSTMENT: '잔액 조정', ACCRUAL: '정기 발생', CARRY_OVER: '이월', EXPIRATION: '만료', EXPIRY: '만료', EXPIRE: '만료', USAGE: '휴가 사용', REVERSAL: '사용 취소', CANCELLATION: '사용 취소', RESTORE: '잔액 복원' };
  return labels[value] ?? '기타 변경';
}
